/* eslint-disable import/no-cycle */
import {
  SET_BALANCE,
  GET_CC,
  GET_ACC,
  SET_TICKET,
  GET_MCC,
} from '../actions/BalanceActions';

import { balanceHelper } from '../../helpers';

const defaultState = () => ({
  datos: [],
  cc: [],
  acc: [],
  mcc: {},
  ticket: {
    data: [],
    title: '',
    referencia: '',
  },
});

const addBalance = (state, { datos }) => {
  const info = balanceHelper.transformBalance(datos);
  return { ...state, datos: info };
};

const getCC = (state, { datos }) => ({
  ...state,
  cc: [...datos],
});

const getACC = (state, { datos }) => ({
  ...state,
  acc: [...datos],
});

const getMCC = (state, { datos }) => ({
  ...state,
  mcc: { ...datos },
});

const setTicket = (state, { info }) => ({
  ...state,
  ticket: { ...info },
});

export default (state = defaultState(), action) => {
  const { type } = action;
  switch (type) {
    case SET_BALANCE:
      return addBalance(state, action.data);
    case GET_CC:
      return getCC(state, action.info);
    case GET_ACC:
      return getACC(state, action.info);
    case GET_MCC:
      return getMCC(state, action.info);
    case SET_TICKET:
      return setTicket(state, action);
    default:
      return state;
  }
};
